import './Header.css'

const Header = ()=>{
    return (
    <header>
        <h1 className="header__title">Country App</h1>
    </header>
    )}

    export default Header